import { createTranslations } from '@/i18n/types';

const translations = createTranslations({
  en: {
    title: 'Achievements',
    achievementsTitle: 'Trophies',
    counter: '{earned} / {total}',
    locked: 'Nothing earned yet',
    loading: 'Loading…',
    userNotFound: 'User not found',
    secret: 'Secret achievement',
    unlockedAt: 'Earned {date}',
    progress: 'Progress',
    reward: 'Reward',
    claimReward: 'Claim reward',
    depositToUnlock: 'Deposit to unlock',
    recentReceivers: 'Recently earned by',
    noOneUnlocked: 'Nobody earned this yet',
    you: 'You',
    today: 'Today',
    receivedBy: 'Earned by',
    playerOne: 'player',
    playerFew: 'players',
    playerMany: 'players',
    achievementUnlocked: 'Achievement unlocked: {title}',
    achievementUnlockedFallback: 'Achievement unlocked!',
    whatIsThis: 'What is this?',
    categoryAll: 'All',
    categoryCases: 'Cases',
    categoryUpgrades: 'Upgrades',
    categoryContracts: 'Contracts',
    categoryDeposits: 'Deposits',
    categorySteam: 'Steam',
    categoryFriends: 'Friends',
    categoryActivity: 'Activity',
    categorySecret: 'Secret',
    categoryRushmid: 'Rush Mid',
  },
  ru: {
    title: 'Ачивки',
    achievementsTitle: 'Трофеи',
    counter: '{earned} / {total}',
    locked: 'Пока ничего не получено',
    loading: 'Загрузка…',
    userNotFound: 'Пользователь не найден',
    secret: 'Секретная ачивка',
    unlockedAt: 'Получено {date}',
    progress: 'Прогресс',
    reward: 'Награда',
    claimReward: 'Забрать награду',
    depositToUnlock: 'Пополни, чтобы забрать',
    recentReceivers: 'Недавно получили',
    noOneUnlocked: 'Пока никто не получил',
    you: 'Ты',
    today: 'Сегодня',
    receivedBy: 'Получили:',
    playerOne: 'игрок',
    playerFew: 'игрока',
    playerMany: 'игроков',
    achievementUnlocked: 'Получена ачивка: {title}',
    achievementUnlockedFallback: 'Ачивка получена!',
    whatIsThis: 'Что это такое?',
    categoryAll: 'Все',
    categoryCases: 'Кейсы',
    categoryUpgrades: 'Апгрейды',
    categoryContracts: 'Контракты',
    categoryDeposits: 'Пополнения',
    categorySteam: 'Steam',
    categoryFriends: 'Друзья',
    categoryActivity: 'Активность',
    categorySecret: 'Секретные',
    categoryRushmid: 'Rush Mid',
  },
  uz: {
    title: 'Yutuqlar',
    achievementsTitle: 'Kuboklar',
    counter: '{earned} / {total}',
    locked: 'Hali hech narsa olinmagan',
    loading: 'Yuklanmoqda…',
    userNotFound: 'Foydalanuvchi topilmadi',
    secret: 'Maxfiy yutuq',
    unlockedAt: '{date} da olindi',
    progress: 'Jarayon',
    reward: 'Mukofot',
    claimReward: 'Mukofotni olish',
    depositToUnlock: 'Olish uchun toʻldir',
    recentReceivers: 'Yaqinda oldilar',
    noOneUnlocked: 'Hali hech kim olmadi',
    you: 'Siz',
    today: 'Bugun',
    receivedBy: 'Oldi:',
    playerOne: 'oʻyinchi',
    playerFew: 'oʻyinchi',
    playerMany: 'oʻyinchi',
    achievementUnlocked: 'Yutuq ochildi: {title}',
    achievementUnlockedFallback: 'Yutuq ochildi!',
    whatIsThis: 'Bu nima?',
    categoryAll: 'Barchasi',
    categoryCases: 'Keyslar',
    categoryUpgrades: 'Yangilanishlar',
    categoryContracts: 'Shartnomalar',
    categoryDeposits: "To'ldirish",
    categorySteam: 'Steam',
    categoryFriends: "Do'stlar",
    categoryActivity: 'Faollik',
    categorySecret: 'Maxfiy',
    categoryRushmid: 'Rush Mid',
  },
});

export default translations;
